import { getLocaleExtraDayPeriodRules } from '@angular/common';
import { Component, Input } from '@angular/core';
import { scaleImg } from 'src/app/shared/helpers/scale_img';
import { StoreService } from 'src/app/shared/services/store.service';

@Component({
    selector: 'app-block-features',
    templateUrl: './block-features.component.html',
    styleUrls: ['./block-features.component.scss']
})
export class BlockFeaturesComponent {
    layout: 'classic' | 'boxed' = 'boxed';

    featuresBlock;
    features;

    constructor(store : StoreService) {
        this.featuresBlock = store.features;
        let layout = this.featuresBlock?.layout;
        if (layout && ['classic', 'boxed'].includes(layout))
            this.layout = layout;
        this.features = this.featuresBlock?.items;
        if (this.features)
            for (let feature of this.features) {
                feature.icon = scaleImg(feature.icon);
            }
    }

    isIcon(icon) {
        return ['fi-free-delivery-48', 'fi-24-hours-48', 'fi-payment-security-48', 'fi-tag-48'].includes(icon);
    }

    getIconWidth(feature) {
        return feature["icon_width"] ? feature["icon_width"] : 40;
    }

    getIconHeight(feature) {
        return feature["icon_height"] ? feature["icon_height"] : 40;
    }
}
